/**
 * File: inventory.js
 * Project: educore
 * Created Date: 2019-03-14
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class InventoryController {
    // @ngInject
    constructor($scope, $rootScope, localStorageService, $state, MEDICALCONSTANT, authService) {

        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
        $scope.existingBatchId = false
        let schoolId = localStorageService.get('school_id')
        let userId = localStorageService.get('user_id')
        authService.callAPI(MEDICALCONSTANT.API_GET_DELIVERED_DETAILS + schoolId, "GET", {}, (response) => {
            if (response.result && response.result.data && response.result.data.data) {
                $scope.productList = response.result.data.data
                _.defer(function() {
                    $scope.$apply();
                });
            }
        })
        $scope.addProductFromToList = () => {
            let len = $scope.productList.length
            if (len % 2 === 0) {
                $scope.productList.push({
                    "div_color": false
                })
            } else {
                $scope.productList.push({
                    "div_color": true
                })

            }
        }
        $scope.saveProducts = () => {
            let batchArray = []
            $scope.batchError = []
            $scope.batchErrorCount = 0
            _.each($scope.productList, function(each, index) {
                if (batchArray.indexOf(each.batch_no) === -1) {
                    batchArray.push(each.batch_no)
                } else {
                    $scope.batchErrorCount++
                        $scope.batchError[index] = "Same batch Id"
                }
            })
            let medicineList = []
            _.each($scope.productList, function(each) {
                each.errors = {}
                let eachObj = {
                    medicine_name: each.medicine_name ? each.medicine_name : null,
                    quantity: each.quantity ? each.quantity : null,
                    company_name: each.company_name ? each.company_name : null,
                    vials_count: each.vials_count ? each.vials_count : null,
                    category: each.category ? each.category : null,
                    medicine_type: each.medicine_type ? each.medicine_type : null,
                    price: each.price ? each.price : null,
                    mfg_date: each.mfg_date ? each.mfg_date : null,
                    exp_date: each.exp_date ? each.exp_date : null,
                    batch_no: each.batch_no ? each.batch_no : null,
                    school_id: each.school_id ? each.school_id : schoolId
                }
                eachObj.purchase_id = each.purchase_id ? each.purchase_id : null
                medicineList.push(eachObj)
            })
            if (medicineList.length === $scope.productList.length && $scope.batchErrorCount === 0) {
                if ($scope.productList.length === 0) {
                    toastr.error("Please add atleast one medicine")
                    return false
                }
                let medicineObj = {
                    medicine_list: medicineList,
                    school_id: schoolId,
                    user_id: userId
                }
                authService.callAPI(MEDICALCONSTANT.API_SAVE_MEDICINE_DETAILS, "POST", medicineObj, (response) => {
                    if (response.result && response.result.data && response.result.data.data) {
                        toastr.success("Medicine added successfully")
                        $state.go('inventoryList')
                    }
                })
            }
        }
        $scope.removeProduct = (product, index) => {
            if ($scope.productList.length > 1) {
                $scope.productList.splice(index, 1);
            }
        }
    }
}
export default InventoryController



// WEBPACK FOOTER //
// ./src/app/medical/controllers/inventory/inventory.js